import { render, staticRenderFns } from "./EmOrder.vue?vue&type=template&id=60ea2fd2&"
import script from "./EmOrder.vue?vue&type=script&lang=js&"
export * from "./EmOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "EmOrder.vue"
export default component.exports